import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function PaystackCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [msg, setMsg] = useState("Verifying your payment…");
  const reference = params.get("reference") || params.get("trxref");
  useEffect(() => {
    if (!reference) { setMsg("No payment reference found."); return; }
    api.get(`/billing/paystack/verify/${reference}`)
      .then(({ data }) => {
        if (data.status === "success") {
          toast.success(`Added ${data.granted_credits} credits via Paystack`);
          setMsg("Payment verified. Redirecting…");
        } else {
          toast.error("Payment was not successful.");
          setMsg("Payment was not successful.");
        }
        setTimeout(() => nav("/billing"), 1200);
      })
      .catch(() => { setMsg("Could not verify payment."); toast.error("Could not verify payment."); });
    // eslint-disable-next-line
  }, []);
  return (
    <div className="k-canvas" data-testid="paystack-callback"
      style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p className="k-muted" data-testid="paystack-callback-msg">{msg}</p>
    </div>
  );
}
